import styled from "styled-components";

export const Page = styled.div`
	padding: 2rem;
	max-width: 900px;
	margin: 0 auto;
`;

export const Header = styled.div`
	margin-bottom: 2rem;
`;

export const BackButton = styled.button`
	background: transparent;
	border: none;
	color: #667eea;
	font-size: 0.9rem;
	cursor: pointer;
	margin-bottom: 1rem;
	padding: 0.5rem 0;

	&:hover {
		text-decoration: underline;
	}
`;

export const HeaderContent = styled.div`
	h1 {
		font-size: 1.75rem;
		font-weight: 700;
		color: #1f2937;
		margin: 0 0 0.5rem 0;
	}
`;

export const SectionInfo = styled.p`
	font-size: 0.9rem;
	color: #6b7280;
	margin: 0;
`;

export const Body = styled.div`
	background: white;
	border-radius: 8px;
	padding: 2rem;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const Form = styled.form`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
`;

export const FormRow = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1rem;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

export const FormGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const Label = styled.label`
	font-size: 0.9rem;
	font-weight: 600;
	color: #374151;

	.required {
		color: #ef4444;
		margin-left: 0.25rem;
	}
`;

export const Input = styled.input`
	padding: 0.75rem;
	border: 1px solid #d1d5db;
	border-radius: 6px;
	font-size: 0.9rem;
	box-sizing: border-box;

	&:focus {
		outline: none;
		border-color: #667eea;
		box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
	}

	&::placeholder {
		color: #9ca3af;
	}
`;

export const Textarea = styled.textarea`
	padding: 0.75rem;
	border: 1px solid #d1d5db;
	border-radius: 6px;
	font-size: 0.9rem;
	min-height: 100px;
	resize: vertical;
	box-sizing: border-box;
	font-family: inherit;

	&:focus {
		outline: none;
		border-color: #667eea;
		box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
	}

	&::placeholder {
		color: #9ca3af;
	}
`;

export const FormActions = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 1rem;
	margin-top: 1rem;
`;

export const CancelButton = styled.button`
	padding: 0.75rem 2rem;
	background: #f3f4f6;
	color: #6b7280;
	border: none;
	border-radius: 6px;
	font-size: 0.9rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s;

	&:hover {
		background: #e5e7eb;
	}
`;

export const SubmitButton = styled.button`
	padding: 0.75rem 2rem;
	background: #667eea;
	color: white;
	border: none;
	border-radius: 6px;
	font-size: 0.9rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s;

	&:hover:not(:disabled) {
		background: #5568d3;
		transform: translateY(-1px);
		box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
	}

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
`;
